import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList, Cell } from 'recharts';

const colors = {
  blueTheme: [
    '#3B7EE3',
    '#5E95E8',
    '#9776C9',
    '#66B032',
    '#E1C33E',
    '#FFB0C1',
    '#FFE0C2',],
};


const MimaPercentageBarChart = ({ data }) => {
  const total = data.reduce((acc, entry) => acc + entry.value, 0);

  return (
    <ResponsiveContainer width="100%" height={data.length * 50 + 10}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 20, right: 80, left: 60, bottom: 5 }}
      >
        <XAxis type="number" axisLine={false} tickLine={false} tick={{ display: 'none' }} />
        <YAxis dataKey="name" type="category" axisLine={false} tick={{ fontSize: 12 }} />
        <Bar dataKey="value" barSize={20} fill="#8884d8">
          <LabelList
            dataKey="value"
            position="right"
            formatter={(value) => `${((value / total) * 100).toFixed(2)}%`}
            fill="black"
            style={{ fontSize: "1.4rem" }}
          />
          {colors.blueTheme.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors.blueTheme[index % colors.blueTheme.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
export default MimaPercentageBarChart;